
export class BewerbSpielSatz {
    constructor(satz, id) {
        this.id = satz?.id??id;
        this.k1 = satz?.k1??null;
        this.k2 = satz?.k2??null;
        this.sv1 = satz?.sv1??null;
        this.sv2 = satz?.sv2??null;
    }

    getSatzPunkte(teamId) {
        if ( (!this.k1 && this.k1 != 0) || (!this.k2 && this.k2 != 0) ) return 0
        const kegel = this.k1 - this.k2;
        if (kegel !== 0) {
            return teamId === 1 ? (kegel>0 ? 1 : 0) : kegel < 0 ? 1 : 0;
        } else {
            if ( !this.sv1 || !this.sv2 ) return 0
            const suddenVictory = this.sv1 - this.sv2;
            return teamId === 1 ? suddenVictory>0 ? 1 : 0 : suddenVictory<0 ? 1 : 0;
        }
    }

    suddenVictoryRequired() {
        return this.k1 == this.k2 && this.k1 !== null;
    }

    suddenVictoryIsTied() {
        return this.suddenVictoryRequired() &&
               this.sv1 == this.sv2 && this.sv1 !== null && this.sv2 !== null;
    }
    clear(){
        this.k1 = null
        this.k2 = null
        this.sv1 = null
        this.sv2 = null
    }
}